/** Minimal dashboard palette — aligned with POS (clean surfaces, restrained accents). */
export const DASHBOARD_COLORS = {
  bg: '#f8fafc',
  surface: '#ffffff',
  border: '#e5e7eb',
  text: '#111827',
  textMuted: '#6b7280',
  accent: '#FF5722',
  accentHover: '#E64A19',
  sales: '#059669',
  danger: '#dc2626',
  warning: '#d97706',
  info: '#475569',
  slate: '#334155',
};

export const sectionPaperSx = {
  p: 2.5,
  borderRadius: 2,
  bgcolor: DASHBOARD_COLORS.surface,
  border: `1px solid ${DASHBOARD_COLORS.border}`,
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
};

/** Full-height dashboard row cards (inventory, low stock, best sellers). */
export const dashboardRowCardSx = {
  ...sectionPaperSx,
  height: '100%',
  minHeight: 300,
  display: 'flex',
  flexDirection: 'column',
};

export const sectionTitleSx = {
  fontWeight: 700,
  fontSize: '1rem',
  color: DASHBOARD_COLORS.text,
  letterSpacing: '-0.01em',
};

export const dashboardLinkButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.8125rem',
  color: '#2563eb',
  minWidth: 'auto',
  p: 0,
  '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
};

export const dashboardTableHeadCellSx = {
  fontWeight: 600,
  fontSize: '0.75rem',
  color: DASHBOARD_COLORS.textMuted,
  py: 1.25,
  px: 1.5,
  borderBottom: `1px solid ${DASHBOARD_COLORS.border}`,
  bgcolor: '#f9fafb',
  whiteSpace: 'nowrap',
};

export const dashboardTableBodyCellSx = {
  py: 1.35,
  px: 1.5,
  fontSize: '0.875rem',
  color: DASHBOARD_COLORS.text,
  borderBottom: `1px solid ${DASHBOARD_COLORS.border}`,
};

export const dashboardMetricBoxSx = {
  p: 1.5,
  borderRadius: 1.5,
  border: `1px solid ${DASHBOARD_COLORS.border}`,
  bgcolor: '#fafbfc',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
};
